/** @type {import('./jwtTypes').Parse} */
export const parse = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  
  return /** @type {import('./jwtTypes').Token} */(JSON.parse(jsonPayload))
};

export const revokeToken = async (/** @type {string} */ token, keepAlive = false) => {
  await fetch('/signout/revoke', {
    method: 'get',
    keepalive: keepAlive, 
    headers: new Headers({
        'Authorization': `Bearer ${token}`
    })
  });
};